import React, { useCallback, useEffect } from 'react'
import { useInstData } from 'tyan/public/hooks'
import Schedule from './components/Schedule'

const CATEGORIES = [
	{ id: 1, text: '无需考勤', color: 'transparent', class: 't-noborder' },
	{ id: 2, text: '迟到、早退', color: '#ea7a57' },
	{ id: 3, text: '缺勤', color: '#df5286' },
	{ id: 4, text: '正常', color: '#00B050' },
	{ id: 5, text: '请假', color: '#865fcf' },
	{ id: 6, text: '订餐', color: '#00B050' },
	{ id: 7, text: '未订餐', color: '#ff0000' }
]

// 模拟类型需要，最后代码请删除
const cLength = CATEGORIES.length

const Calendar = props => {
	const { me, setState, me: { state: {
		categories, data, 订餐状态, 是否计薪, oldDate
	} } } = useInstData(props)
	const onDateChange = useCallback((date) => {
		const regenPlan = plan => {
			// 设置为全天事件
			plan.isAllDay = true

			// 模拟描述、类型，最后代码请删除
			plan.categoryID
			plan.desc
			plan.text

			// 以下代码用于处理考勤详细信息(左右色块呈现)
			// plan.categoryID == 1 && (plan.text = "<div style=''></div>")
		}

		Tyan.doPostEvent({
			event: 'GetCalendar',
			data: { date: Ext.Date.localToUtc(date).valueOf() },
			onEnd: ({ errorMessage, DATA, 订餐状态, 是否计薪 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				DATA.forEach(o => regenPlan(o))
				setState({ categories: CATEGORIES, data: DATA, 订餐状态, 是否计薪, oldDate: date })
			}
		})
	}, [])

	const dNow = new Date().valueOf()
	const tooltipTemplate = useCallback((props) => {
		// console.log('template props:', props)
		return <div className='t-tooltip' dangerouslySetInnerHTML={{ __html: props.desc }} />
	}, [])

	const onStatusChange = (date, type) => {
		Tyan.doPostEvent({
			event: 'StatusChange',
			data: { date, type },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				onDateChange(oldDate)
			}
		})
	}

	const show = (date) => {
		var d1 = new Date(date)
		var d2 = new Date(dNow)
		if (d1.getFullYear() == d2.getFullYear() &&
			d1.getMonth() == d2.getMonth() &&
			d1.getDate() == d2.getDate()) {
			if (d2.getHours() < 10) {
				return true
			}
			return false
		}
		else {
			return date > dNow
		}
	}

	const onDefaultStatusChange = (type) => {
		const strType = type == '订餐' ? '不订餐' : '订餐'
		Tyan.pubForm.showConfirm(`修改默认为${strType}？`,
			() => Tyan.doPostEvent({
				event: 'DefaultStatusChange',
				data: {},
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
						return
					}
					onDateChange(oldDate)
				}
			})
		)
	}

	const scheduleProps = {
		// readOnly,
		// viewType = 'Day',			// 默认'Day', 可用值:'Day', 'Week', 
		// headerRows,
		// cssClass,
		rowAutoHeight: false, // 自动行高(多个重叠会推高)，默认true
		// firstDayOfWeek = 0,
		// date: dateProp, // 传入新增时将置选择日期
		// interval = 1,
		// startHour, endHour,
		// planTextColor = 'white',	// plan文本颜色，默认'white'
		// showHeaderBar = true,
		showTooltip: true,
		tooltipTemplate,
		field: {
			categoryID: 'categoryID',		// plans中的categoryID
			categoryText: 'text', // categories中用于呈现的字段，可为回调
			// categoryColor: 'color',		// categories中用于呈现背景颜色的字段 
			categoryCssClassField: 'class',	//categories中用于呈现事件的class字段
			planStartTime: 'startTime',	// plans中的开始时间(int值)
			planEndTime: 'endTime', // plans中的结束时间(int值)
			planText: 'text'			// Plan用于呈现的文本或回调，形式为字段名或字段名数据 或返回结果为字符串或字符串数据
		},
		categories: categories,
		plans: data,
		buttons: [{ text: 订餐状态 == '订餐' ? '取消订餐' : '订餐', icon: 'utensils', handler: () => onDefaultStatusChange(订餐状态), cdt: () => 是否计薪 },],	// {text, icon, handler}	handler为回调函数, text, icon 为文本，所有参数初始化时有效
		// 	/*		* contextMenu:形如{text, icon, disabled, cdt, handler, items}
		// 			*   handler 与 items 二选一，items优先，即如果有items则handler无效
		// 			*   handler, cdt 只能为回调函数
		// 			*   items 为子项数组
		// 			*   text, icon, disabled 均可为直接值或回调函数
		// 			*   回调函数形式为 func(data)，其中data由onGetData生成 */
		// planContextMenu, cellContextMenu,	// 右键菜单
		planContextMenu: [
			{ text: '不订餐', icon: 'plus', handler: data => onStatusChange(data.startTime, '不订餐'), cdt: data => data.categoryID == 6 && show(data.startTime) },
			{ text: '订餐', icon: 'plus', handler: data => onStatusChange(data.startTime, '订餐'), cdt: data => data.categoryID == 7 && show(data.startTime) }
		],
		//cellContextMenu: [{ text: '订餐', icon: 'plus', handler: data => { console.log('cell context callback:', data) } }],
		// planTemplate,
		onDateChange,	// 选择日期改变时回调，参数(date:Date)
		// onChangePlan, // 修改计划回调，修改内容为[categoryID]或时间, 参数:(newPlan, oldPlan) 
		// onAddPlan, // 新增计划回调，参数:(plan) 内容含[categoryID]及时间
		// onEditPlan, // 修改计划回调，参数:(plan) 原Plan信息
		// onDeletePlan, // 删除计划回调，参数:(plan)原Plan信息
	}

	return <Schedule scheduleProps={scheduleProps} />
}

export default Calendar